import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./_styles.scss";

interface HeadingProps {
  name: string;
  onClickRight?: () => void;
  style?: React.CSSProperties;
}

export default function Heading({ name, onClickRight, style }: HeadingProps) {
  return (
    <div className="heading-row" style={style}>
      <div>
        <h1>{name}</h1>
      </div>
      <span onClick={() => (onClickRight ? onClickRight!() : () => {})}>
        {onClickRight ? <FontAwesomeIcon icon={faAdd} /> : <div></div>}
      </span>
    </div>
  );
}
